var flickitySliders = document.querySelectorAll('.flickity-slider');
flickitySliders.forEach(slider => {
  var flkty = new Flickity( slider, {
    cellAlign: 'center',
    contain: true,
    freeScroll: false,
    prevNextButtons: false
  });
});

  // // Get the cell button group and buttons
  // var cellButtonGroup = document.querySelector('.custom-navigation');
  // var cellButtons = cellButtonGroup.querySelectorAll('.custom-navigation .slide-button');

  // if (cellButtonGroup) {
  //   // Update selected cellButtons
  //   flkty.on('select', function () {
  //     console.log('selected');
  //       cellButtons.forEach(function (button) {
  //           button.classList.remove('is-selected');
  //       });
  //       cellButtons[flkty.selectedIndex].classList.add('is-selected');
  //   });
    
  //   // Select cell on button click
  //   cellButtons.forEach(button => {
  //      button.addEventListener('click', function (event) {
  //       var index = this.getAttribute('data-index');
  //        console.log('clicked', index);
  //       flkty.select(index);
  //     });
  //   });
  
  // }

